import { AbstractControl, ValidationErrors, Validator, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
@Directive({
    selector: '[appMaxValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValidator, multi: true }]
})
export class MaxValidator implements Validator {

    @Input('appMaxValidator') maxValue: number;
    @Input('maxOrEqual') maxOrEqual = false;

    validate(c: AbstractControl): ValidationErrors {
        if ((!this.maxValue && this.maxValue !== 0) || (!c.value && c.value !== 0))
            return null;

        const val = Number(c.value);
        if (isNaN(val))
            return null;

        if (this.maxOrEqual && val >= this.maxValue)
            return { 'maxValue': true };

        if (val > this.maxValue)
            return { 'maxValue': true };

        return null;
    }

    // registerOnValidatorChange?(fn: () => void): void {
    //     throw new Error("Method not implemented.");
    // }
}
